export default __webpack_public_path__ + "static/media/jensen-chan-photo3.fe458529.jpg";